var ConsumerDiscountFinancialDocumentsSectionView = require('../ConsumerDiscountLicenseApplication/ConsumerDiscountFinancialDocumentsSectionView');

module.exports = ConsumerDiscountFinancialDocumentsSectionView;
